import React from 'react'

import { FieldProps } from '../../../../../../../@types/types'
import { AbstractScreenValidationResult } from '../../../../../../../@types/validation-types'
import { getDefaultClasses } from '../../../../../../../utils/style-utils'
import EstateFeaturesYesOrNoChipOptionField from '../estateFeaturesYesOrNoChipOptionField/EstateFeaturesYesOrNoChipOptionField'

export interface SmokingAllowedProps extends FieldProps<AbstractScreenValidationResult> {}

const SmokingAllowed: React.FC<SmokingAllowedProps> = ({
  insertionData,
  screenName,
  onChange,
  wrapperClassName = getDefaultClasses('full'),
}) => {
  return (
    <div className={wrapperClassName}>
      <EstateFeaturesYesOrNoChipOptionField
        id='smoking-allowed'
        labelTranslationKey={'wizard.screen.otherFacilities.smokingAllowed'}
        estateFeatureKey='nonSmoker'
        screenName={screenName}
        insertionData={insertionData}
        onChange={onChange}
        invertLogic={true}
      />
    </div>
  )
}

export default SmokingAllowed
